<template>
  <div class="grid">
    <div class="col-12">
      <div class="card">
        <Toast />
        <Toolbar class="mb-4">
          <template v-slot:start>
            <div class="my-1">
              <div class="col-12 section_title">EDITAR PRESUPUESTO</div>
            </div>
          </template>

          <template v-slot:end>
            <Button
              label="REGRESAR"
              icon="pi pi-arrow-left"
              class="p-button p-component p-button-text mr-2"
              @click="goBack()"
            />

            <Button
              label="GUARDAR"
              icon="pi pi-save"
              class="p-button-success mr-2"
              @click="save()"
            />
          </template>
        </Toolbar>

        <div class="">
          <div class="">
            <div class="formgrid grid">
              <div class="field col-2">
                <label for="name">NÚMERO</label>
                <InputText
                  disabled
                  v-model="form.document_number"
                  id="detail"
                  type="text"
                  class="inputfield w-full"
                />
              </div>

              <div class="field col-5">
                <label for="cliente" style="display: block">CLIENTE</label>
                <AutoComplete
                  v-model="form.cliente"
                  :suggestions="filteredMod"
                  @complete="searchMDO($event)"
                  field="name"
                  :dropdown="true"
                  @item-select="newItemMOD = selectedMOD"
                  id="base"
                  class="inputfield w-full"
                />
              </div>

              <div class="field col-5">
                <label for="name">OBSERVACIONES</label>
                <InputText
                  v-model="form.observations"
                  id="observations"
                  type="text"
                  class="inputfield w-full"
                />
              </div>

            </div>
          </div>

          <div class="">
            <div class="formgrid grid">
              <div class="field col-2">
                <label for="date_at">Fecha</label>
                <InputText
                  v-model="form.date_at"
                  id="date_at"
                  type="date"
                  class="inputfield w-full"
                />
              </div>

              <div class="field col-2">
                <label for="detail">Cond. de Venta </label>
                <Dropdown
                    id="currency"
                    v-model="form.terms_of_sale"
                    :options="tipos"
                    class="w-full"
                    optionLabel="label"
                    optionValue="value"
                    required="false"
                    autofocus
                />
                </div>                
                <div class="field col-2">
                <label for="detail">Forma de Retiro </label>
                <Dropdown
                    id="currency"
                    v-model="form.delivery_form"
                    :options="deliveries"
                    class="w-full"
                    optionLabel="label"
                    optionValue="value"
                    required="false"
                    autofocus
                />
              </div>


              <div class="field col-2">
                <label for="delivery_term">Plazo Entrega</label>
                <InputText
                  v-model="form.delivery_term"
                  id="delivery_term"
                  type="text"
                  class="inputfield w-full"
                />
              </div>

              <div class="field col-2">
                <label for="offer_days">Dias Oferta</label>
                <InputText
                  v-model="form.offer_days"
                  id="offer_days"
                  type="text"
                  class="inputfield w-full"
                />
              </div>

              <div class="field col-2">
                <label for="currency" style="display: block">Moneda</label>
                <Dropdown
                    id="currency"
                    v-model="form.currency"
                    :options="monedas"
                    class="w-full"
                    optionLabel="label"
                    optionValue="value"
                    required="false"
                    autofocus
                />
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <div class="col-12">
            
      <div class="card">
        <div class="my-1">
          <div class="col-12 section_subtitle">Productos</div>
        </div>

        <div class="">
          <div class="formgrid grid">
            <div class="field col-6">
              <label for="base">Producto</label>
              <AutoComplete
                v-model="selectedProduct"
                :suggestions="filteredProducts"
                @complete="searchProduct($event)"
                field="name"
                :dropdown="true"
                @item-select="selectProduct()"
                id="base"
                class="inputfield w-full"
              />
            </div>
            
            <div class="field col-6">
              <label for="cantidad">Detalle</label>
              <InputText
                :disabled="!newItem"
                v-model="details"
                id="details"
                type="text"
                class="inputfield w-full"
                placeholder="Detalle o config. adicional"
              />
            </div>
            <!-- PLISAS -->
            <div class="" v-if="newItem && (newItem.type_id==0 || newItem.type_id==3)">
              <div class="formgrid grid">
                <div class="field col-4">
                  <label for="calidad">Material</label> 
                    <Dropdown
                        :disabled="!newItem"
                        id="material_id"
                        v-model="material_id"
                        :options="materiales"
                        class="w-full"
                        optionLabel="name"
                        optionValue="id"
                        required="false"
                        autofocus
                    />
                </div>
                <div class="field col-1">
                  <label for="ancho">Base</label>
                  <InputText
                    :disabled="!newItem"
                    v-model="ancho"
                    id="ancho"
                    @change="refreshPlisas()"
                    type="text"
                    class="inputfield w-full"
                  />
                </div>
                <div class="field col-1" >
                  <label for="alto">Alto</label>
                  <InputText
                    :disabled="!newItem"
                    v-model="alto"
                    id="alto"
                    type="text"
                    class="inputfield w-full"
                  />
                </div>
                <div class="field col-1">
                  <label for="base">Espesor</label>
                  <InputText
                    :disabled="!newItem"
                    v-model="espesor"
                    id="base"
                    type="text"
                    class="inputfield w-full"
                  />
                </div>
                <div class="field col-1">
                  <label for="base">Plisas x PL</label>
                  <InputText
                    :disabled="!newItem"
                    v-model="plisas_x_pl"
                    id="plisas_x_pl"
                    type="text"
                    @change="refreshPlisas()"
                    class="inputfield w-full"
                  />
                </div>
                <div class="field col-1">
                  <label for="base">Plisas</label>
                  <InputText
                    :disabled="!newItem"
                    v-model="plisas"
                    id="plisas"
                    type="text"
                    class="inputfield w-full"
                  />
                </div>
                <div class="field col-3">
                  <label for="calidad">Calidad</label>                  
                  <Dropdown
                      :disabled="!newItem"
                      id="calidad_id"
                      v-model="calidad_id"
                      :options="calidades"
                      class="w-full"
                      optionLabel="label"
                      optionValue="value"
                      required="false"
                      autofocus
                  />
                </div>
              </div>
            </div>

            <!-- SIN PLISAS -->
            <div class="" v-if="newItem && newItem.type_id==1">
              <div class="formgrid grid">
                <div class="field col-2">
                  <label for="calidad">Material</label> 
                    <Dropdown
                        :disabled="!newItem"
                        id="material_id"
                        v-model="material_id"
                        :options="materiales"
                        class="w-full"
                        optionLabel="name"
                        optionValue="id"
                        required="false"
                        autofocus
                    />
                </div>
                <div class="field col-2">
                  <label for="ancho">Base</label>
                  <InputText
                    :disabled="!newItem"
                    v-model="ancho"
                    id="ancho"
                    type="text"
                    class="inputfield w-full"
                  />
                </div>
                <div class="field col-2" >
                  <label for="alto">Alto</label>
                  <InputText
                    :disabled="!newItem"
                    v-model="alto"
                    id="alto"
                    type="text"
                    class="inputfield w-full"
                  />
                </div>
                <div class="field col-2">
                  <label for="base">Espesor</label>
                  <InputText
                    :disabled="!newItem"
                    v-model="espesor"
                    id="base"
                    type="text"
                    class="inputfield w-full"
                  />
                </div>
                <div class="field col-2">
                  <label for="base">Mallas</label>
                  <InputText
                    :disabled="!newItem"
                    v-model="mallas"
                    id="mallas"
                    type="text"
                    class="inputfield w-full"
                  />
                </div>
                
              </div>
            </div>

            <!-- FILTROS -->
            <div class="" v-if="newItem && newItem.type_id==2">
              <div class="formgrid grid">
                <div class="field col-3 w-100">
                  <label for="diametro_interior">Diametro Interior</label>
                  <InputText
                    :disabled="!newItem"
                    v-model="diametro_interior"
                    id="diametro_interior"
                    type="text"
                    class="inputfield w-full"
                  />                  
                </div>
                <div class="field col-3 w-100" v-if="newItem && newItem.type_id>0">
                  <label for="diametro_exterior">Diametro Exterior</label>
                  <InputText
                    :disabled="!newItem"
                    v-model="diametro_exterior"
                    id="diametro_exterior"
                    type="text"
                    class="inputfield w-full"
                  />                  
                </div>
                <div class="field col-3">
                  <label for="base">Espesor</label>
                  <InputText
                    :disabled="!newItem"
                    v-model="espesor"
                    id="base"
                    type="text"
                    class="inputfield w-full"
                  />
                </div>

                <div class="field col-3" >
                  <label for="alto">Alto</label>
                  <InputText
                    :disabled="!newItem"
                    v-model="alto"
                    id="alto"
                    type="text"
                    class="inputfield w-full"
                  />
                </div>
                
              </div>
            </div>

          </div>
        </div>

        <div class="">
              <div class="formgrid grid">
                <div class="field col-2">
                  <label for="cantidad">Cantidad</label>
                  <InputText
                   :disabled="!newItem"
                    v-model="cantidad"
                    id="cantidad"
                    type="text"
                    class="inputfield w-full"
                    placeholder="Cantidad"
                  />
                </div>

                <div class="field col-3">
                  <label for="precio">Precio</label>
                  <InputText
                   :disabled="!newItem"
                    v-model="costo"
                    id="precio"
                    type="text"
                    class="inputfield w-full"
                    placeholder="Precio"
                  />
                </div>

                <div class="field col-2">
                  <label for="descuento">% Descuento</label>
                  <InputText
                   :disabled="!newItem"
                    v-model="descuento"
                    id="descuento"
                    type="text"
                    class="inputfield w-full"
                    placeholder="Descuento"
                  />
                </div>

                <div class="field col-5">
                  <label for="planos">Planos</label>
                  <MultiSelect
                    v-model="selectedPlanes"
                    :options="planes"
                    optionLabel="name"
                    placeholder="Elije los planos"
                    :filter="true"
                    class="multiselect-custom w-full w-100"
                  >
                    <template #value="slotProps">
                      <div
                        class="country-item country-item-value"
                        v-for="option of slotProps.value"
                        :key="option.code"
                      >
                        <img
                          src="https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png"
                          class="mr-2"
                          width="18"
                        />
                        <div>{{ option.name }}</div>
                      </div>
                      <template
                        v-if="!slotProps.value || slotProps.value.length === 0"
                      >
                        Elije los planos
                      </template>
                    </template>
                    <template #option="slotProps">
                      <div class="country-item">
                        <img
                          src="https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png"
                          class="mr-2"
                          width="18"
                        />
                        <div>{{ slotProps.option.name }}</div>
                      </div>
                    </template>
                  </MultiSelect>
                </div>

            </div>
              
          </div>

        <div class="">
          <div class="formgrid grid">
            <div class="field col-4">
            </div>
            <div class="field col-4">
              <Button :disabled="!cantidad && !precio && !newItem"  @click="addItem(newItem)" label="Agregar Producto" 
                icon="pi pi-plus" class="p-button-success inputfield w-full mt-5" />
            </div>
          </div>
        </div>

        <div class="">
          <DataTable
            :value="items"
             dataKey="id" 
            class="p-datatable-sm"
            responsiveLayout="scroll"
          >
            <template #header> Productos </template>
            <Column header="" >
              <template #body="slotProps">
                  <Button icon="pi pi-times" class="p-button-rounded p-button-danger" @click="delItem(slotProps.data)"></Button>
              </template>
            </Column>
           <Column headerClass="" field="cantidad" header="Cantidad" headerStyle="max-width: 20%">
              <template #body="slotProps">
                {{ slotProps.data.cantidad }}
              </template>
            </Column>
            <Column field="name" header="Descripción"></Column>
            <Column field="costo" header="Pr. Unitario"></Column>
             <Column field="descuento" header="% Desc."></Column> 
            <Column header="Importe">
                <template #body="slotProps">
                    <div class="flex justify-content-between">
                      <div>
                        <span>{{toUsd(slotProps.data.importe)}}</span>
                      </div>
                      <div>
                        <span>{{toArs(slotProps.data.importe)}}</span>
                      </div>
                    </div>
                
                </template>
            ></Column>
          </DataTable>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CrudService from "./../../services/crud.service.js";

export default {
  data() {
    return {
      routeName: null,
      form: {
        document_number: '00000000',
        terms_of_sale: 0,
        delivery_form: 0,
        cliente: null,
        date_at: new Date(),
        delivery_term: '',
        offer_days: '',
        observations: '',
        items: [],
        currency: 'USD',
      },
      mod: [],
      items: [],
      planes: [],
      selectedPlanes: [],

      actualFormula: "",
      costo: 0,
      cantidad: 1,
      descuento: 0,
      products: null,
      details: '',
      filteredProducts: null,
      newItem: null,
      selectedProduct: null,
      alto: null,
      ancho: null,
      espesor: null,
      calidad_id: null,
      material_id: null,
      diametro_interior: null,
      diametro_exterior: null,
      mallas: null,
      plisas: null,
      plisas_x_pl: null,
      materiales: null,

      clientes: null,
      mods: null,
      newItemMOD: null,
      filteredMod: null,
      selectedMod : null,
      actualFormulaMOD: "",

      submitted: false,
      validationErrors: null,


      dolarValue: 0,
      ciif: 0.17,
      mpi: 0.17,
      moi: 0.24,
      margen: 0,
      tipos: [
        { value: 0, label: "Contado" },
        { value: 1, label: "Crédito" }
      ],
      deliveries: [
        { value: 0, label: "En Tienda" },
        { value: 1, label: "Delivery" }
      ],
      monedas: [
        { value: 'USD', label: "Dolar Divisa U$S" },
        { value: 'CASH', label: "Dolar Billete USD" },
        { value: 'PESOS', label: "Peso $" }
      ],
      calidades: [
        { value: 0, label: "G2" },
        { value: 1, label: "G4" },
        { value: 2, label: "M5-M6" },
        { value: 3, label: "F7" },
        { value: 4, label: "F8-F9" },
      ],
      materials: [],
    };
  },
  computed: { },
  created() {
    this.routeName = this.$route.name;
  },
  mounted() { 
    CrudService.getCRUD("presupuestos",  this.$route.params.id).then((data) => {
      this.form = { ...data };
      this.form.terms_of_sale = parseInt(data.terms_of_sale)
      this.form.delivery_form = parseInt(data.delivery_form)
      if (data.detalle) {
        data.detalle.forEach((item) => {
          let name = item.producto.name ? item.producto.name : '';
          this.items.push({
            id: item.producto_id,
            name: name,
            description: name,
            costo: item.price,
            descuento: item.discount,
            cantidad: item.quantity,
            alto: item.alto,
            ancho: item.ancho,
            espesor: item.espesor,
            plisas: item.plisas,
            plisas_x_pl: item.plisas_x_pl,
            calidad_id: item.calidad_id,
            mallas: item.mallas,
            material_id: item.material_id,
            diametro_interior: item.diametro_interior,
            diametro_exterior: item.diametro_exterior,
            importe: item.total,
            details: item.details,
          });
        });
      }
    });
    CrudService.getCRUD("cliente", "cliente").then((data) => (this.clientes = data));
    CrudService.getCRUD("productos").then((data) => (this.products = data));
    CrudService.getCRUD("material").then((data) => (this.materiales = data));
    CrudService.getCRUD("planos").then((response) => {this.planes = response;});
    CrudService.getCRUD("configuraciones").then(response => {
        this.dolarValue = response.dolarvalue; 
        this.ciif = response.ciif; 
        this.mpi = response.mpi; 
        this.moi = response.moi; 
        this.margen = response.margen; 
    });
  },
  methods: {
    refreshPlisas() {
      this.plisas = 0;
      if (this.ancho && this.plisas_x_pl) {
        this.plisas = (parseFloat(this.ancho) / 308 * parseFloat(this.plisas_x_pl)).toFixed(2);
      }
    },
    selectProduct() {
      this.newItem = this.selectedProduct;
      let prod = this.products.filter((item) => item.id==this.newItem.id);
      this.costo = 1;
      if (prod.length) {
        this.alto = prod[0].alto;
        this.ancho = prod[0].ancho;
        this.espesor = prod[0].espesor;
        this.plisas = prod[0].plisas;
        this.plisas_x_pl = prod[0].plisas_x_pl;
        this.diametro_interior = prod[0].diametro_interior;
        this.diametro_exterior = prod[0].diametro_exterior;         
        this.mallas = prod[0].mallas;
        this.material_id = parseInt(prod[0].material_id);
        this.calidad_id = parseInt(prod[0].calidad_id);
        //this.costo = prod[0].costo;
        
        let margin = (prod[0].costo * this.margen / 100 );
        let cost = (prod[0].costo*1 + margin);
        this.costo = (this.form.currency == 'PESOS') ? (cost * this.dolarValue).toFixed(2) : cost.toFixed(2);
        if (isNaN(this.costo)) {
          this.costo = isNaN(cost) ? 0 : cost.toFixed(2);
        }
      }
    },
    toArs(value) {
      let calc = value * this.dolarValue;    
      return calc.toLocaleString("es-AR", {
        style: "currency",
        currency: "ARS",
      });
    },
    toUsd(value) {
      return value.toLocaleString("es-AR", {
        style: "currency",
        currency: "USD",
      });
    },
    delItem(itemId){
      let index = this.items.findIndex(item => item.id == itemId);
      this.items.splice(index, 1);
    },
    delItemMOD(itemId) {
      let index = this.mod.findIndex(item => item.id == itemId);
      this.mod.splice(index, 1);
    },
    displayErrors(errors) {
      for (let key in errors) {
        this.validationErrors.push({ field: key, message: errors[key] });

        let error = errors[key];
        this.$toast.add({
          severity: "error",
          summary: "Error!",
          detail: error[0],
          life: 3000,
        });
      }
    },
    searchProduct(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredProducts = [...this.products];
        } else {
          this.filteredProducts = this.products.filter((prod) => {
            return prod.name
              .toLowerCase()
              .startsWith(event.query.toLowerCase());
          });
        }
      }, 250);
    },
    searchMDO(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredMod = [...this.clientes];
        } else {
          this.filteredMod = this.clientes.filter((prod) => {
            return prod.name
              .toLowerCase()
              .startsWith(event.query.toLowerCase());
          });
        }
      }, 250);
    },
    addItem() {
      if (this.newItem) {
        let descuento = (this.newItem.costo*this.cantidad) * this.descuento / 100;
        let margin = (this.newItem.costo * this.margen / 100 );
        //let cost = (this.newItem.costo*1 + margin);
        let cost = (this.costo*1 + margin);
        //let importe = ((cost + margin) * this.cantidad) - descuento;
        let importe = (cost * this.cantidad) - descuento;
        let planos = this.selectedPlanes;
        this.items.push({
          id: this.newItem.id,
          name: this.newItem.name,
          description: this.newItem.description,
          //costo: this.newItem.costo,
         costo: (this.form.currency == 'PESOS') ? (cost * this.dolarValue).toFixed(2) : cost.toFixed(2),
          descuento: descuento,
          cantidad: this.cantidad,
          alto: this.alto,
          ancho: this.ancho,
          espesor: this.espesor,
          plisas: this.plisas,
          plisas_x_pl: this.plisas_x_pl,
          calidad_id: this.calidad_id,
          material_id: this.material_id,
          diametro_interior: this.diametro_interior,
          diametro_exterior: this.diametro_exterior,
          mallas: this.mallas,
          details: this.details,
          importe: importe,
          planos: planos,
          currency: this.form.currency,
        });

        this.selectedPlanes = null;
        this.actualFormula = null;
        this.newItem = null;
        this.details = '';
        this.selectedProduct = null;
      }
    },
    goBack() {
      this.$router.push("/presupuestos");
    },
    save() {
      this.submitted = true;
      this.form.cliente_id = this.form.cliente.id;
      this.form.items = this.items;
      //this.form.terms_of_sale = this.terms_of_sale;

      CrudService.updateCRUD("presupuestos", "presupuestos", this.form).then(
        (data) => {
          this.validationErrors = [];
          if (data.status == 400) {
            this.displayErrors(data.data);
          } else {
            this.$toast.add({
              severity: "success",
              summary: "Éxito!",
              detail: "Actualizado correctamente.",
              life: 3000,
            });

            this.$router.push("/presupuestos");
          }
        }
      );
    },
  },
};
</script>


<style scoped>

  .section_subtitle {
    font-size: 1.2rem;
    font-weight: bold;
    color: #1261b1;
    margin-bottom: 1rem;
  }

  .card {
    padding-top: 0.25rem;
  }

</style>